import type { ProjectPlanSliceState } from '.';

import { PLAN_NAME } from '@readme/iso';

/**
 * Our initial `ProjectPlanSlice` state. On the Hub, this state is immediately
 * overridden by SSR props and replaced before any components connect to it.
 * This initial state simply provides us with some starting data during testing
 * and when running Styleguidist.
 */
const initialState: ProjectPlanSliceState = {
  activePlan: PLAN_NAME.FREE,
  isTrial: true,
  plan: PLAN_NAME.FREE,
  details: {
    cost: 0,
    createdAt: new Date('November 10, 2022 03:24:00'),
    endDate: new Date('November 10, 2022 03:24:00'),
    is_active: false,
    members: 0,
    name: '',
  },
  features: {
    versions: 1,
    api_access: true,
    custom_domain: false,
    custom_pages: false,
    whitelabel: false,
    errors: false,
    password: false,
    glossary: false,
    landing_page: false,
    pdf: false,
    usability: false,
    stylesheet: false,
    javascript: false,
    html: false,
    extra_html: false,
    user_analytics: false,
    doc_metrics: true,
    variables: false,
    jwt: true,
    changelogs: false,
    reference: true,
    guides: false,
    recipes: false,
    discussions: false,
    admins: false,
    healthCheck: false,
    metricsExports: false,
    owlbotExports: false,
    reusableContent: false,
  },
  override: undefined,
};

export default initialState;
